import { IApplicationState } from '../../types/redux';

export function selectCurrentRegionId(state: IApplicationState) {
  return state.geoLocation.currentRegion.id;
}
